<img [obgImageContent]="titleIconImageKey" class="icon-list-title" *ngIf="iconEnabled && titleIconImageKey" />
<span [innerHtml]="titleText" class="icon-list-title" *ngIf="titleText && titleEnabled"></span>

<div [ngClass]="['icon-list-container', realmStyling?.class || '']" *ngIf="icons.length">
	<ng-container *ngFor="let icon of icons; trackBy: trackByIcon">
		<span
			[ngClass]="['icon-list-container', realmStyling?.class || '']"
			*ngIf="!icon.link?.url && !icon.route; else link"
		>
			<obg-lazy-image
				*ngIf="icon.logo?.url"
				[attr.test-id]="'img_' + icon.key"
				[src]="icon.logo?.url"
				[alt]="icon.logo?.altText"
			></obg-lazy-image>
		</span>
		<ng-template #link>
			<a
				[obgInteraction]="uiInteraction"
				[obgRouteLink]="{ route: icon.route, url: icon.link?.url }"
				[obgRouteLinkActive]="icon.route"
				[target]="icon.link?.target"
				[attr.test-id]="'link_' + icon.key"
			>
				<obg-lazy-image
					*ngIf="icon.logo?.url"
					[attr.test-id]="'img_' + icon.key"
					[src]="icon.logo?.url"
					[alt]="icon.logo?.altText"
				></obg-lazy-image>
			</a>
		</ng-template>
	</ng-container>
</div>
